export default __webpack_public_path__ + "static/media/flag_arg.bdffb554.svg";